import { html, Page, View } from 'rune-ts';
import { LayoutView } from '../../../components/cells/Layout/LayoutView';
import { footer_links } from '../../../components/cells/Footer/constant';
import { type BaseLayoutOptions } from '../../../../features/Core/service';
import { NumericString } from '../../../../features/Membership/type';
import { MyCommissionDetail } from './views/MyCommissionDetail';
import { MY_PAGE_MENU_MAP, type MyPageMenuOptions } from '../constant';
import { MyPageMenu } from '../views/MyPageMenu/MyPageMenu';
import klass from './MembershipCommissionDetail.module.scss';
import { QuestionServiceB } from '../../../../features/Question/outbound/back';

export interface MyCommissionPageData {
  layout_options: BaseLayoutOptions;
  url: string;
  membership_token: string;
  project_domain_name_map: Record<NumericString, string>;
  commissionRequestId: string;
  question?: Awaited<ReturnType<typeof QuestionServiceB.getQuestionsByOption>>[0];
}

export class MyCommissionDetailBodyView extends View<MyCommissionPageData> {
  my_page_menu_option_list: MyPageMenuOptions;

  constructor(props: MyCommissionPageData) {
    super(props);

    this.my_page_menu_option_list = Object.values(MY_PAGE_MENU_MAP).map((option) => ({
      ...option,
      active: this.data.url.includes(option.href),
    }));
  }

  override template() {
    const { layout_options } = this.data;
    const { is_mobile } = layout_options;

    return html`
      <div>
        ${is_mobile ? '' : new MyPageMenu({ menu: this.my_page_menu_option_list })}
        <div class="${klass.body}">${new MyCommissionDetail(this.data)}</div>
      </div>
    `;
  }
}

export class MyCommissionDetailPage extends Page<MyCommissionPageData> {
  override template() {
    const { layout_options } = this.data;
    const { is_mobile } = layout_options;

    return html`
      <div>
        ${new LayoutView(
          {
            body: new MyCommissionDetailBodyView(this.data),
            footer_data: { ...footer_links, lang: ET.lang, is_mobile },
          },
          {
            require_top_arrow_button: true,
            full_width: true,
            ...layout_options,
          },
        )}
      </div>
    `;
  }
}
